import React, { useEffect, useState } from 'react';
import { translations } from '../translations';

const NetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const [triedRefresh, setTriedRefresh] = useState(false);
  const [displayLanguage, setDisplayLanguage] = useState("eng");

  useEffect(() => {
    // Get language from localStorage or default to English
    const savedLanguage = localStorage.getItem('displayLanguage') || 'eng';
    setDisplayLanguage(savedLanguage);
  }, []);

  const currentLang = displayLanguage === "ja" ? "ja" : "eng";
  const t = translations[currentLang];

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true);
      if (triedRefresh) {
        window.location.reload(); // Refresh only when connection is back
      }
    };

    const handleOffline = () => {
      setIsOnline(false);
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [triedRefresh]);

  const handleRefresh = () => {
    if (navigator.onLine) {
      window.location.reload();
    } else {
      setTriedRefresh(true); // Just wait until we're online
    }
  };

  if (isOnline) return null;

  return (
    <div style={styles.overlay}>
      {/* Language Toggle Button - Fixed Position */}
      <div className="language-toggle-container" style={{ 
        position: "fixed", 
        top: "20px", 
        right: "20px", 
        zIndex: 10000 
      }}>
        <div className="language-toggle" role="group" aria-label="Language selection">
          <button
            type="button"
            className={`language-toggle-btn ${displayLanguage === "eng" ? "active" : ""}`}
            onClick={() => {
              setDisplayLanguage("eng");
              localStorage.setItem('displayLanguage', 'eng');
            }}
            aria-pressed={displayLanguage === "eng"}
            aria-label={t.switchToEnglish}
          >
            <span className="flag-icon">🇺🇸</span>
            <span className="language-text">En</span>
          </button>
          <button
            type="button"
            className={`language-toggle-btn ${displayLanguage === "ja" ? "active" : ""}`}
            onClick={() => {
              setDisplayLanguage("ja");
              localStorage.setItem('displayLanguage', 'ja');
            }}
            aria-pressed={displayLanguage === "ja"}
            aria-label={t.switchToJapanese}
          >
            <span className="flag-icon">🇯🇵</span>
            <span className="language-text">Ja</span>
          </button>
        </div>
      </div>

      <div style={styles.card}>
        <div style={styles.icon}>📡</div>
        <h2 style={styles.title}>{t.noInternetConnection}</h2>
        <p style={styles.message}>
          {t.offlineMessage}
        </p>

        <button style={styles.retryButton} onClick={handleRefresh}>
          🔁 {t.retryRefresh}
        </button>

        {/* 🌀 Show loading message if refresh is waiting */}
        {triedRefresh && (
          <p style={{ marginTop: '10px', color: '#888' }}>
            🔄 {t.waitingForConnection}
          </p>
        )}

        <hr style={styles.hr} />
        <p style={styles.note}>
          {t.offlineNote}
        </p>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: '#eef4ff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999,
    fontFamily: 'sans-serif',
  },
  card: {
    backgroundColor: '#fff',
    padding: '40px',
    borderRadius: '12px',
    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
    textAlign: 'center',
    maxWidth: '480px',
    width: '90%',
  },
  icon: {
    fontSize: '40px',
    marginBottom: '16px',
    color: '#ff4d4f',
  },
  title: {
    fontSize: '24px',
    margin: '10px 0',
    color: '#333',
  },
  message: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '24px',
  },
  retryButton: {
    padding: '10px 20px',
    backgroundColor: '#4e6ef2',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: '600',
    boxShadow: '0 4px 10px rgba(78, 110, 242, 0.3)',
  },
  hr: {
    margin: '20px 0',
    borderColor: '#eee',
  },
  note: {
    fontSize: '14px',
    color: '#999',
  },
};

export default NetworkStatus;
